import { isServer, QueryClient } from '@tanstack/react-query';

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        retry: false,
      },
      mutations: {
        onError: (error) => {
          console.error('Mutation error:', error);

          // 401 에러 시 에러 페이지로 리다이렉트
          if (error instanceof Error && 'status' in error) {
            const status = (error as { status: number }).status;
            if (status === 401) {
              if (globalThis.window !== undefined) {
                globalThis.window.location.href = '/error?code=session_expired';
              }
            }
          }
        },
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

/**
 * 서버/클라이언트 환경에 맞는 QueryClient 반환
 * - 서버: 매번 새 인스턴스 생성
 * - 브라우저: 싱글톤 패턴
 */
export function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}
